import "./svg/illustration-shopping-cart.svg"

export default {
    name: "illustration-shopping-cart",
    viewBox: "120 120",
}
